// Components
import { useTranslation } from 'react-i18next';
import { ReactInternetSpeedMeter } from '../internet';

// Styles
import './error.styles.scss';
import { use } from 'i18next';
import { useEffect } from 'react';
import { ErrorProperties } from './error.properties';

/**
 * Error Component
 * @description Component to render error
 * @returns {JSX.Element}
 */
export function ErrorComponent(properties: ErrorProperties): JSX.Element {

    // translation function
    const { t } = useTranslation();

    useEffect(() => {
      // Reload the page when the component is onmount
      return () => {
        properties.removeSocketConn();

        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    }, []);

    return <div className="ErrorComponent">
        <i className='las la-exclamation-triangle'></i>
        <div className='title'>
            {t('error.title')}
        </div>
        <div className='description'>
            {t('error.description')}
        </div>
        <div
            onClick={() => window.location.reload()}
            className='Submit'>
            {
                t('error.button')
            }
        </div>
    </div>

}
